import { css } from '@emotion/core';
import CorgixInput from '@veeva/corgix/input';
import Link from '@veeva/corgix/link';
import { useContext } from 'react';
import VerifyCodeFormContext from './VerifyCodeFormContext';
import InputKeys from './InputKeys';
import getTargetAttribute from '../../services/getTargetAttribute';

const VerifyCodeFormDesktop = () => {
    const {
        inputLabel,
        inputRefs,
        onInputChange,
        onKeyDown,
        values,
        error,
        showResendClicked,
        codeSentLabel,
        onCodeResend,
        linkLabel,
        inputsDisabled,
        resendDisabled,
    } = useContext(VerifyCodeFormContext);

    let resendLink;
    if (showResendClicked) {
        resendLink = (
            <span
                css={({ darkGray, linkFontSize }) => css`
                    grid-area: link;
                    text-align: start;
                    color: ${darkGray};
                    font-size: ${linkFontSize};
                `}
            >
                {codeSentLabel}
            </span>
        );
    } else {
        resendLink = (
            <Link
                css={({ darkGray }) => [
                    css`
                        grid-area: link;
                        text-align: start;
                    `,
                    resendDisabled &&
                        css`
                            color: ${darkGray};

                            &:hover,
                            &:active {
                                color: ${darkGray};
                            }
                        `,
                ]}
                onClick={onCodeResend}
                disabled={resendDisabled}
                data-target={getTargetAttribute('resend-code-link')}
            >
                {linkLabel}
            </Link>
        );
    }

    return (
        <div
            css={css`
                display: grid;
                grid-template-columns: min-content auto;
                grid-template-rows: auto;
                grid-template-areas:
                    'label label'
                    'input link'
                    'error error';
                justify-content: start;
                column-gap: 1.667rem;
                margin-left: 54px;
                align-items: center;
            `}
        >
            <span
                css={css`
                    grid-area: label;
                    font-size: 14px;
                    font-weight: bold;
                    margin-bottom: 1rem;
                    text-align: start;
                `}
            >
                {inputLabel}
            </span>
            <div
                css={css`
                    grid-area: input;
                    display: flex;
                    gap: 1rem;
                `}
            >
                {InputKeys.map((key, index) => (
                    <CorgixInput
                        css={css`
                            height: 3.333rem;
                            width: 3.333rem;
                            padding: 0;

                            input {
                                text-align: center;
                                font-size: 2.667rem;
                                border-radius: 8px;
                                width: 100%;
                            }
                        `}
                        key={key}
                        inputRef={(ref) => {
                            inputRefs.current[index] = ref;
                        }}
                        onChange={(e) => onInputChange(e, index)}
                        value={values[index]}
                        onKeyDown={(e) => onKeyDown(e, index)}
                        error={!!error}
                        disabled={inputsDisabled}
                        data-target={getTargetAttribute('code-input')}
                    />
                ))}
            </div>
            {resendLink}
            <span
                css={({ veevaIdErrorLabelBufferHeight, red }) => css`
                    grid-area: error;
                    height: ${veevaIdErrorLabelBufferHeight};
                    margin: 0.333rem 0 0;
                    text-align: start;
                    color: ${red};
                    font-size: 1rem;
                `}
            >
                {error}
            </span>
        </div>
    );
};

export default VerifyCodeFormDesktop;
